(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["xtu-expandable-description"] && !Shopify.designMode) return;
  try {
    (() => {
    class XtuExpandableDescription extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enabled !== 'true') return;

        const body = this.querySelector('[data-xtu-ed-body]');
        const toggle = this.querySelector('[data-xtu-ed-toggle]');
        const labelEl = this.querySelector('[data-xtu-ed-toggle-label]');
        if (!body || !toggle) return;

        const limit = Number(this.dataset.collapsedHeight) || 200;
        const needsToggle = body.scrollHeight > limit + 4;

        if (!needsToggle) {
          this.classList.remove('is-collapsed', 'is-expanded');
          toggle.hidden = true;
          return;
        }

        toggle.hidden = false;
        this.classList.add('is-collapsed');
        this.classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'false');
        if (labelEl) labelEl.textContent = toggle.dataset.labelMore || 'Learn more';

        toggle.addEventListener('click', () => {
          const expanded = this.classList.contains('is-expanded');
          if (expanded) {
            this.classList.remove('is-expanded');
            this.classList.add('is-collapsed');
            toggle.setAttribute('aria-expanded', 'false');
            if (labelEl) labelEl.textContent = toggle.dataset.labelMore || 'Learn more';
          } else {
            this.classList.add('is-expanded');
            this.classList.remove('is-collapsed');
            toggle.setAttribute('aria-expanded', 'true');
            if (labelEl) labelEl.textContent = toggle.dataset.labelLess || 'Show less';
          }
        });
      }
    }

    if (!customElements.get('xtu-expandable-description')) {
      customElements.define('xtu-expandable-description', XtuExpandableDescription);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
